export default class SortUtil {
  static POSITIONS = ["QB", "RB", "WR", "TE", "K", "DEF"];

  static playerByLastNameFirstName(a, b) {
    if (a.lastName === b.lastName) {
      if (a.firstName === b.firstName) return 0;
      return a.firstName < b.firstName ? -1 : 1;
    }
    return a.lastName < b.lastName ? -1 : 1;
  }

  static playerByLineupPos(a, b) {
    if (a === null && b === null) return 0;
    if (a !== null && b === null) return -1;
    if (a === null && b !== null) return 1;

    if (a && b) {
      if (!a.pos && !b.pos) return 0;
      if (a.pos && !b.pos) return -1;
      if (!a.pos && b.pos) return 1;

      const aPosIndex = SortUtil.POSITIONS.indexOf(a.pos);
      const bPosIndex = SortUtil.POSITIONS.indexOf(b.pos);
      if (aPosIndex === bPosIndex)
        return SortUtil.playerByLastNameFirstName(a, b);

      return aPosIndex < bPosIndex ? -1 : 1;
    }
  }
}
